/**
 * The one byte-size formatter. `sizeBytes` on a content-tree unit is null whenever the record
 * holds no size, and an unknown size must read as nothing at all rather than as "0 KB".
 */
export function formatBytes(bytes: number | null | undefined): string {
  if (typeof bytes !== 'number' || !isFinite(bytes) || bytes <= 0) return '';
  if (bytes < 1024) return `${Math.round(bytes)} B`;
  const kilobytes = bytes / 1024;
  if (kilobytes < 1024) return `${Math.round(kilobytes)} KB`;
  const megabytes = kilobytes / 1024;
  if (megabytes < 1024) return `${megabytes.toFixed(megabytes < 10 ? 1 : 0)} MB`;
  return `${(megabytes / 1024).toFixed(1)} GB`;
}
